import { UserInfoApi, ProductsApi, RiskProfilerApi, PromotionApi, PaymentApi, BrokerSubscriptionApi } from '@/api';
import {
	getJWTFromStorage,
	removeJWTFromStorage,
	saveJWTToStorage
} from '@/api/localStorage';

import {
	GET_PRODUCTS,
	GET_RISK_TYPE,
	GET_RISK_PROFILER_INFO,
	GET_DEFAULT_RISK_PROFILER,
	SAVE_RISK_PROFILER_INFO,
	VALIDATE_PROMO,
	GENERATE_PAYU_HASH,
	CREATE_PAYMENT_REQUEST,
	PROCESS_PAYMENT_REQUEST,
	UPDATE_PAYMENT_REQUEST,
	GET_USER_SUBSCRIPTION,
	GET_USER_TRANSACTIONS,
	GET_USER_REPORTS,
	GET_USER_LAST_REPORT,
	SEND_PAYMENT_SUCCESS_MAIL,
	SEND_PAYMENT_FAILED_MAIL,
	SEND_RISK_PROFILER_MAIL_NOTIFICATION,
	GET_BROKER_SUBSCRIPTION,
	GET_BROKER_ALL_LEADS,
	GET_ALL_BROKER_PROMOTION,
	EDIT_BROKER_PROMOTION,
	GET_BROKER_PRODUCT,
	UPSERT_BROKER_PROMOTION,
	CREATE_RZP_PAYMENT_REQUEST,
	PROCESS_RZP_PAYMENT_REQUEST
} from '@/store/actions.type';

import {
	SET_PRODUCTS,
	SET_RISK_TYPE,
	SET_RISK_PROFILER_INFO,
	SET_DEFAULT_RISK_PROFILER,
	SET_PAYU_HASH,
	SET_PAYMENT_REQUEST,
	SET_PAYMENT_PROCESS,
	SET_USER_SUBSCRIPTION,
	SET_USER_TRANSACTIONS,
	SET_USER_REPORTS,
	SET_GET_BROKER_ALL_LEADS

} from '@/store/mutations.type';
import { data } from 'jquery';

const state = {
	leads: {},
	products: {},
	risktype: {},
	riskprofilerinfo: {},
	defaultriskanswers: {},
	payuhash: {},
	paymentrequest: {},
	paymentprocess: {},
	subscription: {},
	transactions: {},
	reports: {}
}

const actions = {
	async [GET_PRODUCTS] ({ commit }) {
		return ProductsApi.getProducts().then(({ data }) => {
			commit(SET_PRODUCTS, data.response.products);

			return data.response.products;
		})
	},

	async [GET_RISK_TYPE] ({ commit }, params) {
		return RiskProfilerApi.getRiskType(params).then(({ data }) => {
			commit(SET_RISK_TYPE, data.response);
			return data.response;
		});
	},

	async [GET_RISK_PROFILER_INFO] ({ commit }, params) {
		return RiskProfilerApi.getRiskProfilerInfo().then(({ data }) => {
			commit(SET_RISK_PROFILER_INFO, data.response.riskProfiler);

			return data.response.riskProfiler;
		});
	},

	async [GET_DEFAULT_RISK_PROFILER] ({ commit }, params) {
		return RiskProfilerApi.getDefaultRiskProfiler().then(({ data }) => {
			commit(SET_DEFAULT_RISK_PROFILER, data.response.riskAnswers);

			return data.response.riskAnswers;
		});
	},

	async [SEND_RISK_PROFILER_MAIL_NOTIFICATION] ({commit}, params){
         return RiskProfilerApi.sendRiskProfilerMail(params).then(({data}) =>{
            return data.response;
		 });
	},

	async [SAVE_RISK_PROFILER_INFO] ({ commit }, params) {
		return RiskProfilerApi.saveRiskProfilerInfo(params).then(({ data }) => {
			return data.response.sucess;
		});
	},

	async [VALIDATE_PROMO] ({ commit }, params) {
		return PromotionApi.validatePromo(params).then(({ data }) => {
			return data.response
		})
	},

	async [GENERATE_PAYU_HASH] ({ commit }, params) {
		return PaymentApi.generatePayUHash(params).then(({ data }) => {
			commit(SET_PAYU_HASH, data.response.hash);

			return data.response.hash;
		});
	},

	async [CREATE_PAYMENT_REQUEST] ({ commit }, params) {
		return PaymentApi.createPaymentRequest(params).then(({ data }) => {
			commit(SET_PAYMENT_REQUEST, data.response);

			return data.response;
		});
	},

	async [CREATE_RZP_PAYMENT_REQUEST] ({ commit }, params) {
		return PaymentApi.createRzpPaymentRequest(params).then(({ data }) => {
			commit(SET_PAYMENT_REQUEST, data.response);

			return data.response;
		});
	},



	async [PROCESS_PAYMENT_REQUEST] ({ commit }, params) {
		return PaymentApi.processPaymentRequest(params).then(({ data }) => {
			var response = params;
			Object.assign(response, data.response.subscription);
			commit(SET_PAYMENT_PROCESS, response);

			return data.response.subscription;
		});
	},

	async [UPDATE_PAYMENT_REQUEST] ({ commit }, params) {
		return PaymentApi.updatePaymentRequest(params).then(({ data }) => {

			return data.response;
		});
	},

	async [GET_USER_SUBSCRIPTION] ({ commit }) {

		return PaymentApi.getSubscription().then(({ data }) => {
			commit(SET_USER_SUBSCRIPTION, data.response.subscription);

			return data.response.subscription;
		});
	},

	async [GET_USER_TRANSACTIONS] ({ commit }) {
		return PaymentApi.getTransactions().then(({ data }) => {
			commit(SET_USER_TRANSACTIONS, data.response.transactions);

			return data.response.transactions;
		});
	},

	async [GET_USER_REPORTS] ({ commit }) {
		return UserInfoApi.getUserReports().then(({ data }) => {
			commit(SET_USER_REPORTS, data.response.reports);

			return data.response.reports;
		});
	},

	async [GET_USER_LAST_REPORT] ({}) {
		return UserInfoApi.getLastUserReport().then(({ data }) => {
			return data.response.report;
		});
	},

	[SEND_PAYMENT_SUCCESS_MAIL] ({ }, paymentSuccessObj) {
		return PaymentApi.sendPaymentSuccessMail(paymentSuccessObj);
	},

	[SEND_PAYMENT_FAILED_MAIL] ({ }, paymentFailedObj) {
		return PaymentApi.sendPaymentFailedMail(paymentFailedObj);
	},

	async [GET_BROKER_SUBSCRIPTION] ({ }, params) {
		return BrokerSubscriptionApi.getBrokerTransactions(params).then(({ data }) => {
			// commit(SET_USER_TRANSACTIONS, data.response.transactions);
			return data.response;
		});
	},

	async [GET_BROKER_ALL_LEADS] ({ }, params) {
		return BrokerSubscriptionApi.getBrokerAllLeads(params).then(({data}) => {
			this.commit(SET_GET_BROKER_ALL_LEADS, data.response);

			return data.response.leadsGenerated;
		})
	},

	async [GET_ALL_BROKER_PROMOTION] ({ }, params) {
		return PromotionApi.getAllBrokerPromotion().then(({data}) => {
			return data.response.promotions;
		})
	},

	async [EDIT_BROKER_PROMOTION] ({ }, params) {
		return PromotionApi.editBrokerPromotion(params).then(({data}) => {
			return data.response.promotion;
		})
	},

	async [GET_BROKER_PRODUCT] ({ }, params) {
		return PromotionApi.getBrokerProduct(params).then(({data}) => {
			return data.response.brokerProduct;
		})
	},

	async [UPSERT_BROKER_PROMOTION] ({ }, params) {
		return PromotionApi.upsertBrokerPromotion(params).then(({data}) => {
			return data.response.success;
		})
	}
}

const mutations = {
	[SET_GET_BROKER_ALL_LEADS] (state, data) {
		state.leads = data
	},

	[SET_PRODUCTS] (state, data) {
		state.products = data
	},

	[SET_RISK_TYPE] (state, data) {
		state.risktype = data
	},

	[SET_RISK_PROFILER_INFO] (state, data) {
		state.riskprofilerinfo = data
	},

	[SET_DEFAULT_RISK_PROFILER] (state, data) {
		state.defaultriskanswers = data
	},

	[SET_PAYU_HASH] (state, data) {
		state.payuhash = data;
	},

	[SET_PAYMENT_REQUEST] (state, data) {
		state.paymentrequest = data;
	},

	[SET_PAYMENT_PROCESS] (state, data) {
		state.paymentprocess = data;
	},

	[SET_USER_SUBSCRIPTION] (state, data) {
		if (data) {
			data.percentage = data.remainingAccess / data.totalPremiumAccess * 100;
			if (data.remainingAccess == 0) {
				data.remainingAccess = "0";
			}
			if (data.remainingDays < 2) {
				data.accessLabel = 'Report'
			} else {
				data.accessLabel = 'Reports'
			}
		}
		state.subscription = data;
	},

	[SET_USER_TRANSACTIONS] (state, data) {
		state.transactions = data;
	},

	[SET_USER_REPORTS] (state, data) {
		state.reports = data;
	},
}

export default {
	state,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js